import { Card, CardContent, Chip, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Logo from '../../../assets/img/brand/logo.png'
import { formatNumber } from '../../../utils/global.utils'

import AspectRatioIcon from '@mui/icons-material/AspectRatio'
import EmailIcon from '@mui/icons-material/Email'
import HomeWorkIcon from '@mui/icons-material/HomeWork'
import { backgroundBlue, linkBlue, normalGrey } from '../../../components/Basic/colors'
import { DoughnutGroup } from './doughnut-group.component'
import { useTranslation } from 'react-i18next'

export const GroupSummaryComponent = ({ sites }) => {
    const [surface, setSurface] = useState(null)
    const { t } = useTranslation('connect', { keyPrefix: 'groupDashboard' })
    const scroll = () => {
        let id = 'dashboard-group-table'
        const element = document.getElementById(id)
        if (element) {
            // 👇 Will scroll smoothly to the top of the next section
            element.scrollIntoView({ behavior: 'smooth' })
        }
    }

    useEffect(() => {
        let surface = 0
        sites.forEach((site) => {
            if (site.Surface) surface += parseInt(site.Surface)
        })
        setSurface(surface)
    }, [sites])

    return (
        <Grid container justifyContent={'space-between'} spacing={2}>
            <Grid item xs={12}>
                <Card>
                    <CardContent style={{ position: 'relative' }}>
                        <Grid container spacing={1}>
                            <Grid item md={7} xs={7}>
                                <Grid container direction="column" spacing={0.25}>
                                    <Grid item sx={{ ml: -1 }}>
                                        <img
                                            src={Logo}
                                            alt="agrid_logo"
                                            style={{
                                                objectFit: 'contain',
                                                maxWidth: '80%',
                                                maxHeight: 60,
                                            }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            marginTop: 5,
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: 30,
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <AspectRatioIcon style={{ color: normalGrey }} />
                                        </div>
                                        <Typography
                                            component="div"
                                            style={{
                                                fontSize: 14,
                                                color: normalGrey,
                                                marginLeft: 2,
                                            }}
                                        >
                                            {surface ? formatNumber(surface) : '-'} m²
                                            {/* {selectedCompany?.FirstName && selectedCompany?.LastName
                        ? `${selectedCompany?.FirstName} ${selectedCompany?.LastName}`
                        : selectedCompany?.Email
                        ? selectedCompany?.Email
                        : "Gestionnaire à définir"} */}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            marginTop: 5,
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: 30,
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <HomeWorkIcon style={{ color: normalGrey }} />
                                        </div>

                                        <Typography
                                            component="div"
                                            style={{
                                                fontSize: 14,
                                                color: linkBlue,
                                                marginLeft: 2,
                                                cursor: 'pointer',
                                            }}
                                            onClick={scroll}
                                        >
                                            {t('building', { count: sites.length })}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item md={5} xs={5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <DoughnutGroup sites={sites} />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12}>
                <Card>
                    <CardContent style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography
                            component="div"
                            style={{
                                fontSize: 14,
                                color: normalGrey,
                            }}
                        >
                            Contact Agrid:
                        </Typography>

                        <Chip
                            icon={<EmailIcon />}
                            label="Charles Moreau"
                            variant="outlined"
                            style={{ cursor: 'pointer', marginLeft: 5 }}
                            onClick={() => (window.location = 'mailto:charles.moreau@a-grid.com')}
                        />
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}

export const Item = ({ icon, number }) => {
    return (
        <Grid item md={12} style={{ display: 'flex', alignItems: 'center' }}>
            <div
                style={{
                    marginRight: 5,
                    fontSize: 30,
                    color: backgroundBlue,
                    fontWeight: 'bold',
                    width: 30,
                    textAlign: 'end',
                }}
            >
                {number}
            </div>{' '}
            {icon}
        </Grid>
    )
}

export const Details = ({ question, answer }) => {
    return (
        <Grid item md={12}>
            <span style={{ fontWeight: 600 }}>{question}</span>: {answer}
        </Grid>
    )
}
